import { AsyncPipe, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Signal } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { BlogService } from '@pyg-services/blog/blog.service';
import { BlogItemComponent } from './blog-item/blog-item.component';
import { SubscribeComponent } from '../subscribe/subscribe.component';
import { TryDemoComponent } from '../try-demo/try-demo.component';
import { map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';

interface FirstArticleType {
  title: string;
  preview: string;
  image: string;
  date: string;
  slug: string;
}

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
  imports: [
    RouterLink,
    SlicePipe,
    AsyncPipe,
    BlogItemComponent,
    SubscribeComponent,
    TryDemoComponent,
    RouterOutlet,
    TranslatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogComponent {
  public data$ = this.blogService.data$;
  public firstArticleData: Signal<FirstArticleType | undefined>;

  constructor(private blogService: BlogService) {
    this.blogService.getAllArticles();

    const firstArticleData$ = this.data$.pipe(
      map((articles) => {
        const firstArticle = articles[0];
        const mainBlock = firstArticle?.content.components.find(
          (component) => component.component === 'main-block',
        );
        if (mainBlock) {
          return {
            title: mainBlock.title ?? '',
            preview: mainBlock.preview ?? '',
            image: mainBlock.image?.filename ?? '',
            date: mainBlock.date ?? '',
            slug: firstArticle.slug,
          };
        }
        return;
      }),
    );

    this.firstArticleData = toSignal(firstArticleData$);
  }
}
